import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#4f227d',
      light: '#7b4da8',
      dark: '#371755',
      contrastText: '#fff',
    },
    secondary: {
      main: '#ffe200',
      light: '#ffeb3d',
      dark: '#e6cb00',
      contrastText: '#1a1a1a',
    },
    background: {
      default: '#f8f6fa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 0 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 44,
          textTransform: 'none',
          fontWeight: 600,
          '@media (min-width: 600px)': { minHeight: 36 },
        },
      },
    },
    MuiIconButton: { styleOverrides: { root: { minWidth: 48, minHeight: 48 } } },
    MuiPaper: { styleOverrides: { root: { boxShadow: '0 2px 12px rgba(79, 34, 125, 0.08)' } } },
    MuiTextField: { defaultProps: { variant: 'outlined', size: 'small' } },
    MuiChip: { styleOverrides: { root: {} } },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, #4f227d 0%, #371755 100%)',
          boxShadow: '0 2px 12px rgba(79, 34, 125, 0.25)',
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: { backgroundColor: '#fff', boxShadow: '0 -2px 12px rgba(79, 34, 125, 0.08)' },
      },
    },
  },
});
